export default "__VITE_ASSET__BcjB6E1i__"